// extracted by mini-css-extract-plugin
export default {"wrap":"QJ-z","articleImagesWrap":"RJ-z","articleImage":"SJ-z","singleImage":"TJ-z"};